import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/login/Thevillain.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4bce280b")

_pushScopeId("data-v-4bce280b")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  key: 0,
  class: "formModel"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "items" }
const _hoisted_5 = { class: "items" }
const _hoisted_6 = { class: "pass-text" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("记住密码")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_9 = { class: "login-footer" }
const _hoisted_10 = { class: "copyright" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_12 = { class: "text" }
const _hoisted_13 = {
  class: "cas",
  style: {"text-align":"right"}
}
const _hoisted_14 = {
  key: 0,
  style: {"color":"lightslategray","font-weight":"bolder"},
  href: "casredirect.html"
}
const _hoisted_15 = {
  key: 1,
  class: "ft"
}
const _hoisted_16 = { class: "content" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "lin tow" }, "忘记密码")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "QA" }, [
  /*#__PURE__*/_createVNode("p", { class: "h" }, "1、无法访问到我的账号？"),
  /*#__PURE__*/_createVNode("p", { class: "d" }, "可能你的账号尚未建立或者用户密码错误，请联系指导老师处理。"),
  /*#__PURE__*/_createVNode("p", { class: "h" }, "2、忘记账号和密码？"),
  /*#__PURE__*/_createVNode("p", { class: "d" }, "请老师帮你修改账号密码。"),
  /*#__PURE__*/_createVNode("p", { class: "h" }, "3、没有账号？"),
  /*#__PURE__*/_createVNode("p", { class: "d" }, "请老师为你新建账号。"),
  /*#__PURE__*/_createVNode("p", { class: "h" }, "4、反馈"),
  /*#__PURE__*/_createVNode("p", { class: "d" }, "如果以上方式无法解决您的问题，请通过以下方式联系我们来反馈您的信息，非常感谢！"),
  /*#__PURE__*/_createVNode("p", { class: "d" }, "哲寻公司邮箱：find_soft@163.com")
], -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_20 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UserOutlined = _resolveComponent("UserOutlined")
  const _component_a_input = _resolveComponent("a-input")
  const _component_LockOutlined = _resolveComponent("LockOutlined")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_my_button = _resolveComponent("my-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.showPwd)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.softConfig.softName), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_a_input, {
              placeholder: "请输入账号",
              size: "large",
              value: _ctx.form.code,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.code = $event)),
              onPressEnter: _ctx.handleLogin
            }, {
              prefix: _withId(() => [
                _createVNode(_component_UserOutlined)
              ]),
              _: 1
            }, 8, ["value", "onPressEnter"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_a_input, {
              placeholder: "请输入密码",
              size: "large",
              type: "password",
              onPressEnter: _ctx.handleLogin,
              value: _ctx.form.password,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event))
            }, {
              prefix: _withId(() => [
                _createVNode(_component_LockOutlined)
              ]),
              _: 1
            }, 8, ["onPressEnter", "value"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_a_checkbox, {
              modelValue: _ctx.remember,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.remember = $event))
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode("a", {
              class: "fp-button",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handlePasswordClick && _ctx.handlePasswordClick(...args)), ["stop"]))
            }, "忘记密码?")
          ]),
          _createVNode(_component_my_button, {
            class: "sure-button",
            bgcolor: "orange",
            onClick: _ctx.handleLogin,
            loading: _ctx.loading
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.softConfig.copyRightValue), 1),
            _hoisted_11,
            _createVNode("div", _hoisted_12, "V" + _toDisplayString(_ctx.softConfig.version), 1)
          ]),
          _createVNode("div", _hoisted_13, [
            (_ctx.softConfig.useCas==='1')
              ? (_openBlock(), _createBlock("a", _hoisted_14, "使用CAS账号登录"))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createVNode(_component_my_button, {
              class: "Return",
              onClick: _ctx.handleCancelClick
            }, {
              default: _withId(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["onClick"]),
            _hoisted_20
          ])
        ]))
  ]))
})